export default () => {
    return (routeIds, shipmentRecord) => {
        if(!routeIds || !shipmentRecord) {
            return [];
        }

        if(!shipmentRecord.refId || !shipmentRecord.trackingId || typeof shipmentRecord.total !== 'number' || shipmentRecord.total < 0) {
            return [];
        }
        else {
            return routeIds.slice();
        }
    };
};


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/shipment_record/shipment_route.filter.js